import React from 'react';
import { useAuth } from './AuthContext';
import { useDI } from './DIContext';
import { useSettings } from './SettingsContext';

/**
 * Legacy shim — merges the three split contexts so every existing consumer
 * continues to work while it migrates to useDI / useAuth / useSettings.
 *
 * ISP note: components that only need repos will still re-render on auth
 * changes until they migrate to useDI() directly.
 */
export const useServices = () => ({
  ...useDI(),
  ...useAuth(),
  ...useSettings(),
});

/** No-op — actual providers are DIProvider → AuthProvider → SettingsProvider in App.tsx. */
export const ServiceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>{children}</>
);
